<script>
import AddBtn from "@/components/buttons/AddBtn.vue";
import Tooltip2Vue from "@/components/Tooltip2Vue/Tooltip2Vue";
import LegoTooltip from "@/components/Lego/LegoTooltip.vue";
import LegoCheck from "@/components/Lego/LegoCheck.vue";
import draggable from "vuedraggable";
import LegoProgressBarWithCompleted from "./LegoProgressBarWithCompleted.vue";
import confetti from "canvas-confetti";

export default {
  props: {
    color: {
      type: String,
      default: "#ef476f",
    },
  },
  components: {
    AddBtn,
    Tooltip2Vue,
    LegoTooltip,
    LegoCheck,
    LegoProgressBarWithCompleted,
    draggable,
  },
  data() {
    return {
      tooltipTitle: "",
      itemInChecklist: "",
      subItemInChecklist: "",
      checklistIdShowNewItem: "",
      buttonsDisabled: [],
      showSubItemInput: null,
      editingItemId: null,
      collapsed: false,
    };
  },
  mounted() {
    this.resizeAll();
  },
  updated() {
    this.resizeAll();
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: {
          name: "checklistItems",
          pull: true,
          put: true,
        },
        disabled: false,
        ghostClass: "ghost",
      };
    },
    checklists() {
      return this.$store.state.lego.card.checklists;
    },
    cardId() {
      return this.$route.params.cardId;
    },
    userLoggedIn() {
      return this.$store.getters.userLoggedIn;
    },
  },
  methods: {
    handleClickOnRenderedItem(event, id) {
      const isLink = event.target.closest("a");
      if (isLink) return;

      this.editingItemId = id;

      this.$nextTick(() => {
        let textarea = this.$refs["textarea-" + id];
        if (Array.isArray(textarea)) textarea = textarea[0];
        if (textarea && textarea.focus) {
          textarea.focus();
          textarea.setSelectionRange(
            textarea.value.length,
            textarea.value.length
          );
        }
      });
    },
    autoLinkText(text) {
      const urlRegex = /\b((https?:\/\/|www\.)[^\s<>"']+)/gi;
      return text.replace(urlRegex, (match) => {
        const href = match.startsWith("http") ? match : `https://${match}`;
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${match}</a>`;
      });
    },
    showSubItemInputField(itemId) {
      this.showSubItemInput = itemId;
      this.$nextTick(() => {
        const input = this.$el.querySelector(
          `#inputSubItemInChecklist-${itemId}`
        );
        if (input) input.focus();
      });
    },
    async onCheckListItemsReorder(checklistItems) {
      console.log("checklistItems", checklistItems);

      const reorderItems = checklistItems?.map((item, index) => ({
        ...item,
        orderCheck: index + 1,
      }));

      console.log("reorderItems", reorderItems);

      await this.$store.dispatch("lego/reorderChecklistItems", reorderItems);
    },
    async onCheckListSubItemsReorder(subItems, parentItemId) {
      const reorderSubItems = subItems.map((subItem, index) => ({
        ...subItem,
        orderCheck: index + 1,
      }));

      await this.$store.dispatch("lego/reorderSubItemsInChecklist", {
        parentItemId,
        reorderSubItems,
      });
    },
    focusOnTooltipTitle() {
      this.$nextTick(() => {
        const input = document.querySelector("#checklistTooltipTitle");
        if (input) {
          input.focus();
        }
      });
    },
    async addChecklist(close) {
      const title = this.tooltipTitle.trim();
      if (!title) return;

      const checklist = {
        legoCardId: this.cardId,
        title,
        createdById: this.userLoggedIn.id,
      };

      await this.$store.dispatch("lego/addChecklist", checklist);

      const lastId = this.checklists[this.checklists.length - 1].id;

      this.closeTooltip(close);
      this.checklistIdShowNewItem = lastId;
      this.toFocusNewItemInChecklist();
    },
    closeTooltip(close) {
      this.tooltipTitle = "";
      close();
    },
    addItemInChecklist() {
      const title = this.itemInChecklist.trim();
      if (!title) return;

      const currentChecklist = this.checklists.find(
        (cl) => cl.id === this.checklistIdShowNewItem
      );

      const item = {
        legoChecklistId: this.checklistIdShowNewItem,
        title,
        createdById: this.userLoggedIn.id,
        orderCheck: currentChecklist.items.length + 1,
        subItems: [],
      };

      this.$store.dispatch("lego/addItemInChecklist", item);

      this.itemInChecklist = "";
    },
    addSubItemInChecklist(parentItem) {
      const title = this.subItemInChecklist.trim();
      if (!title) return;

      const subItem = {
        legoChecklistId: parentItem.legoChecklistId,
        parentItemId: parentItem.id,
        title,
        createdById: this.userLoggedIn.id,
        orderCheck: (parentItem.subItems || []).length + 1,
      };

      this.$store.dispatch("lego/addSubItemInChecklist", subItem);

      this.subItemInChecklist = "";
      this.showSubItemInput = null;
    },
    addItemInChecklistCtrlEnter(ev) {
      if (ev.ctrlKey && ev.keyCode == 13) {
        this.addItemInChecklist();
      }
    },

    closeControlsInItemInChecklist() {
      this.checklistIdShowNewItem = "";
      this.itemInChecklist = "";
    },
    toFocusNewItemInChecklist(id = null) {
      this.checklistIdShowNewItem = id ? id : this.checklistIdShowNewItem;
      this.$nextTick(() => {
        const input = this.$el.querySelector(`#inputNewItemInChecklist`);
        input.focus();
      });
    },

    async deleteItemInChecklist(ev, item) {
      const originalContent = ev.target.innerHTML;
      ev.target.innerHTML =
        '<span><i class="fas fa-spinner fa-spin text-lego-danger"></i></span>';

      try {
        await this.$store.dispatch("lego/deleteItemInChecklist", item);
      } catch (error) {
        ev.target.innerHTML = originalContent;
      }
    },
    async deleteSubItemInChecklist(ev, item) {
      const originalContent = ev.target.innerHTML;
      ev.target.innerHTML =
        '<span><i class="fas fa-spinner fa-spin text-lego-danger"></i></span>';

      try {
        await this.$store.dispatch("lego/deleteSubItemInChecklist", item);
      } catch (error) {
        ev.target.innerHTML = originalContent;
      }
    },
    resizeTextarea(ev) {
      ev.target.style.height = "auto";
      ev.target.style.height = ev.target.scrollHeight + "px";
    },
    resizeAll() {
      if (Object.keys(this.$el).length == 1) return;
      const textareas = this.$el.querySelectorAll(".text-area-item");
      textareas.forEach((textarea) => {
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";
      });
    },
    async setDoneItem(item) {
      const newItem = {
        id: item.id,
        isDone: !item.isDone,
        doneBy: this.userLoggedIn.id,
      };

      this.buttonsDisabled.push(newItem.id);
      await this.$store.dispatch("lego/SetIsDoneItemInChecklist", newItem);
      this.buttonsDisabled = this.buttonsDisabled.filter(
        (id) => id != newItem.id
      );

      // Efecto de celebración sutil cuando se completa
      if (newItem.isDone) {
        this.launchSparkles(item);
      }
    },
    async setDoneSubItem(item) {
      const newItem = {
        id: item.id,
        isDone: !item.isDone,
        doneBy: this.userLoggedIn.id,
      };

      this.buttonsDisabled.push(newItem.id);
      await this.$store.dispatch("lego/SetIsDoneSubItemInChecklist", newItem);
      this.buttonsDisabled = this.buttonsDisabled.filter(
        (id) => id != newItem.id
      );

      // Efecto de celebración sutil cuando se completa
      if (newItem.isDone) {
        this.launchSparkles(item);
      }
    },
    launchSparkles(item) {
      // Encontrar el elemento del checkbox para aplicar el efecto
      const checkboxElement = this.$el.querySelector(
        `[data-item-id="${item.id}"]`
      );
      if (!checkboxElement) return;

      // Obtener el color del progreso del checklist
      const progressColor = this.color || "#085CC0";

      // Aplicar efecto de pulso/glow al checkbox
      checkboxElement.style.transition = "all 0.3s ease";
      checkboxElement.style.transform = "scale(1.2)";
      checkboxElement.style.boxShadow = `0 0 20px ${progressColor}80`;
      checkboxElement.style.filter = "brightness(1.3)";

      // Animar el icono de check con rotación y movimiento
      const checkIcon = checkboxElement.querySelector("svg");
      if (checkIcon) {
        // El SVG tiene un transform: scale(2) en el CSS, así que empezamos desde ahí
        const originalScale = 1.5;

        checkIcon.style.transition =
          "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)";
        checkIcon.style.transform = `scale(${
          originalScale * 1.4
        }) rotate(360deg)`;
        checkIcon.style.fill = progressColor;

        // Movimiento adicional después de la rotación
        setTimeout(() => {
          checkIcon.style.transform = `scale(${
            originalScale * 1.2
          }) rotate(380deg)`;
        }, 200);

        setTimeout(() => {
          checkIcon.style.transform = `scale(${
            originalScale * 1.3
          }) rotate(375deg)`;
        }, 300);

        // Volver al tamaño original después de la animación
        setTimeout(() => {
          checkIcon.style.transform = `scale(${originalScale}) rotate(0deg)`;
          checkIcon.style.fill = "";
          checkIcon.style.transition = "all 0.3s ease";
        }, 400);
      }

      // Restaurar después de la animación
      setTimeout(() => {
        checkboxElement.style.transform = "scale(1)";
        checkboxElement.style.boxShadow = "";
        checkboxElement.style.filter = "";
      }, 300);

      // Efecto adicional de sparkles muy sutiles
      const rect = checkboxElement.getBoundingClientRect();
      const x = (rect.left + rect.width / 2) / window.innerWidth;
      const y = (rect.top + rect.height / 2) / window.innerHeight;

      // Generar colores basados en el color del progreso
      const baseColor = progressColor;
      const lighterColor = this.lightenColor(progressColor, 20);
      const darkerColor = this.darkenColor(progressColor, 20);

      confetti({
        particleCount: 8,
        spread: 30,
        startVelocity: 10,
        angle: 90,
        origin: { x, y },
        colors: [baseColor, lighterColor, darkerColor],
        disableForReducedMotion: true,
        ticks: 60,
        gravity: 0.9,
        scalar: 0.4,
      });
    },
    isDisabled(item) {
      return this.buttonsDisabled.includes(item.id);
    },
    updateItemTitle(ev) {
      this.resizeTextarea(ev);
    },
    saveTitleItem(ev, item) {
      const title = ev.target.value.trim();
      if (!title || title == item.title) return;
      const newItem = { ...item };
      newItem.title = title;

      this.$store.dispatch("lego/updateItemInChecklist", newItem);

      this.focusId = null;
    },

    saveTitleSubItem(ev, item) {
      const title = ev.target.value.trim();
      if (!title || title == item.title) return;
      const newItem = { ...item };
      newItem.title = title;

      this.$store.dispatch("lego/updateSubItemInChecklist", newItem);

      this.focusId = null;
    },
    saveTitleItemCtrlEnter(ev, item) {
      if (ev.ctrlKey && ev.keyCode == 13) {
        this.saveTitleItem(ev, item);
        ev.target.blur();
      }
    },
    saveTitleSubItemCtrlEnter(ev, item) {
      if (ev.ctrlKey && ev.keyCode == 13) {
        this.saveTitleSubItem(ev, item);
        ev.target.blur();
      }
    },
    async deleteChecklist(ev, checklist) {
      const originalContent = ev.target.innerHTML;
      ev.target.innerHTML =
        '<span><i class="fas fa-spinner fa-spin text-lego-danger"></i></span>';

      try {
        await this.$store.dispatch("lego/deleteChecklist", checklist);
      } catch (error) {
        ev.target.innerHTML = originalContent;
      }
    },
    saveTitleChecklist(ev, checklist) {
      const newTitle = ev.target.value.trim();
      ev.target.blur();

      this.$store.dispatch("lego/renameChecklist", {
        id: checklist.id,
        oldTitle: checklist.title,
        newTitle,
        createdById: checklist.createdById,
      });
    },
    updateCardProgress(progress) {
      this.$store.dispatch("lego/updateCardProgress", progress);
    },
    lightenColor(color, percent) {
      const num = parseInt(color.replace("#", ""), 16);
      const amt = Math.round(2.55 * percent);
      const R = (num >> 16) + amt;
      const G = ((num >> 8) & 0x00ff) + amt;
      const B = (num & 0x0000ff) + amt;
      return (
        "#" +
        (
          0x1000000 +
          (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
          (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
          (B < 255 ? (B < 1 ? 0 : B) : 255)
        )
          .toString(16)
          .slice(1)
      );
    },
    darkenColor(color, percent) {
      const num = parseInt(color.replace("#", ""), 16);
      const amt = Math.round(2.55 * percent);
      const R = (num >> 16) - amt;
      const G = ((num >> 8) & 0x00ff) - amt;
      const B = (num & 0x0000ff) - amt;
      return (
        "#" +
        (
          0x1000000 +
          (R > 255 ? 255 : R < 0 ? 0 : R) * 0x10000 +
          (G > 255 ? 255 : G < 0 ? 0 : G) * 0x100 +
          (B > 255 ? 255 : B < 0 ? 0 : B)
        )
          .toString(16)
          .slice(1)
      );
    },
  },
};
</script>

<template>
  <div>
    <div
      class="section-header item-display"
      id="checklistTarea"
      @click="collapsed = !collapsed"
    >
      <div>
        <span>
          <i class="fa-regular fa-circle-check title-icon"></i>
        </span>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
        "
      >
        <span class="title-section">
          Checklists ({{ checklists?.length || 0 }})
        </span>
        <i
          :class="[
            'fas',
            collapsed ? 'fa-chevron-down' : 'fa-chevron-up',
            'chevron-icon',
          ]"
        ></i>
      </div>
    </div>
    <transition name="fade">
      <div v-show="!collapsed">
        <div class="item-display">
          <!-- progreso de todos los checklists -->
          <LegoProgressBarWithCompleted
            class="in-right"
            :itemsChecklists="(checklists || []).map((c) => c.items).flat()"
            :color="color"
            mode="checklists"
            @progress-updated="updateCardProgress"
          />
          <Tooltip2Vue position="bottom-right" class="ml-4">
            <div class="btn-shadow" @click="focusOnTooltipTitle">
              <AddBtn />
              <span>Nuevo Checklist</span>
            </div>
            <template #tooltip="{ close }">
              <div class="tp-lego-container">
                <label for="checklistTooltipTitle">Titulo</label>
                <input
                  v-model="tooltipTitle"
                  id="checklistTooltipTitle"
                  type="text"
                  class="lego-input"
                  @keydown.enter="addChecklist(close)"
                />
                <div class="tp-controls">
                  <vs-button @click="addChecklist(close)"
                    >Crear Checklist</vs-button
                  >
                  <vs-button danger @click="closeTooltip(close)"
                    >Cerrar</vs-button
                  >
                </div>
              </div>
            </template>
          </Tooltip2Vue>
        </div>
        <div
          v-for="(checklist, index) in checklists"
          :key="checklist.id"
          class="checklist"
        >
          <div class="item-display" :id="'checklistTareaTotales' + index">
            <div class="d-flex align-items-center">
              <span>
                <i class="fas fa-list-check title-icon title-box"></i>
              </span>
            </div>
            <header class="header-checklist">
              <input
                type="text"
                class="title lego lego-input title-box"
                @blur="($event) => saveTitleChecklist($event, checklist)"
                @keyup.enter="($event) => saveTitleChecklist($event, checklist)"
                :value="checklist.title"
              />

              <LegoTooltip class="cancel-default-styles trash-icon-checklist">
                <template #button>
                  <span>
                    <i class="fa-regular fa-trash-alt title-icon"></i>
                  </span>
                </template>
                <div>
                  <p>
                    <strong>Eliminar {{ checklist.title }}</strong>
                  </p>
                  <p>
                    Eliminar un checklist es una acción permanente y no se podrá
                    recuperar
                  </p>
                  <div
                    @click="deleteChecklist($event, checklist)"
                    class="btn-delete-checklist py-2"
                  >
                    <span class="text-lego-danger">Eliminar</span>
                  </div>
                </div>
              </LegoTooltip>
            </header>
            <!-- progreso para cada item checklist -->
            <LegoProgressBarWithCompleted
              class="in-right"
              :itemsChecklists="checklist.items"
              :color="color"
              mode="checklists"
            />
          </div>

          <!-- draggable checklist -->
          <draggable
            v-model="checklist.items"
            group="checklist.items"
            class="body"
            @end="onCheckListItemsReorder(checklist.items)"
            :options="dragOptions"
          >
            <div
              v-for="(item, index) in checklist.items"
              :key="item.id"
              class="item-display item-in-checklist"
              :id="'checklistTareaTotalesDetalle' + index"
            >
              <div class="d-flex align-items-center" style="gap: 0.5rem">
                <!-- Indicador de arrastre -->
                <div class="drag-indicator">
                  <i class="fas fa-grip-vertical"></i>
                </div>
                <LegoCheck
                  class="btn-checked"
                  :value="item.isDone"
                  @input="setDoneItem(item)"
                  :waiting="isDisabled(item)"
                  :data-item-id="item.id"
                />
              </div>

              <div class="item-in-checklist--right">
                <span> {{ item.orderCheck }}. </span>
                <textarea
                  :ref="'textarea-' + item.id"
                  v-show="editingItemId === item.id"
                  class="lego-input text-area-item"
                  rows="1"
                  @blur="
                    saveTitleItem($event, item);
                    editingItemId = null;
                  "
                  @keydown.enter="saveTitleItemCtrlEnter($event, item)"
                  @input="updateItemTitle($event)"
                  :value="item.title"
                ></textarea>
                <div
                  v-show="editingItemId !== item.id"
                  class="checklist-rendered"
                  v-html="autoLinkText(item.title)"
                  @click="handleClickOnRenderedItem($event, item.id)"
                ></div>
                <div class="checklistItemControls">
                  <i
                    v-b-tooltip.hover="'Agregar subitem'"
                    class="fas fa-circle-plus pointer mx-2 fa-2x"
                    @click="showSubItemInputField(item.id)"
                  ></i>
                  <LegoTooltip position="top" class="z-more">
                    <span
                      @click="deleteItemInChecklist($event, item)"
                      class="text-lego-danger"
                      >Eliminar item</span
                    >
                  </LegoTooltip>
                </div>
              </div>
              <!-- Campo de texto para agregar subítems -->
              <div v-if="showSubItemInput === item.id" class="sub-item-input">
                <textarea
                  :id="`inputSubItemInChecklist-${item.id}`"
                  class="lego-input textarea-item"
                  placeholder="¿De qué trata este subítem?"
                  @keydown.esc="showSubItemInput = null"
                  @keydown.enter="addSubItemInChecklist(item)"
                  @input="resizeTextarea($event)"
                  v-model="subItemInChecklist"
                ></textarea>
                <div class="checklist-add-item--controls">
                  <vs-button @click="addSubItemInChecklist(item)"
                    >Agregar Subítem</vs-button
                  >
                  <vs-button danger @click="showSubItemInput = null"
                    >Cerrar</vs-button
                  >
                </div>
              </div>
              <!-- Subítems -->
              <draggable
                v-if="item.subItems && item.subItems.length > 0"
                v-model="item.subItems"
                group="subItems"
                class="sub-items"
                @end="onCheckListSubItemsReorder(item.subItems, item.id)"
                :options="dragOptions"
              >
                <div
                  v-for="subItem in item.subItems"
                  :key="subItem.id"
                  class="item-display item-in-checklist sub-item"
                >
                  <div class="d-flex align-items-center" style="gap: 0.5rem">
                    <!-- Indicador de arrastre para sub-items -->
                    <div class="drag-indicator">
                      <i class="fas fa-grip-vertical"></i>
                    </div>
                    <LegoCheck
                      class="btn-checked"
                      :value="subItem.isDone"
                      @input="setDoneSubItem(subItem)"
                      :waiting="isDisabled(subItem)"
                      :data-item-id="subItem.id"
                    />
                  </div>

                  <div class="item-in-checklist--right">
                    <span>{{ item.orderCheck }}.{{ subItem.orderCheck }} </span>
                    <textarea
                      :ref="'textarea-' + subItem.id"
                      v-show="editingItemId === subItem.id"
                      class="lego-input text-area-item"
                      rows="1"
                      @blur="
                        saveTitleSubItem($event, subItem);
                        editingItemId = null;
                      "
                      @keydown.enter="
                        saveTitleSubItemCtrlEnter($event, subItem)
                      "
                      @input="updateItemTitle($event)"
                      :value="subItem.title"
                    ></textarea>
                    <div
                      v-show="editingItemId !== subItem.id"
                      class="checklist-rendered"
                      v-html="autoLinkText(subItem.title)"
                      @click="handleClickOnRenderedItem($event, subItem.id)"
                    ></div>
                    <div class="checklistItemControls">
                      <LegoTooltip position="top" class="z-more">
                        <span
                          @click="deleteSubItemInChecklist($event, subItem)"
                          class="text-lego-danger"
                          >Eliminar item</span
                        >
                      </LegoTooltip>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </draggable>

          <footer class="item-display">
            <div
              class="in-right checklist-add-item"
              id="addchecklistTareaTotales"
            >
              <button
                @click="toFocusNewItemInChecklist(checklist.id)"
                class="btn-shadow"
                v-if="checklistIdShowNewItem != checklist.id"
              >
                <AddBtn style="height: auto" />
                <span>Nuevo item</span>
              </button>
              <div v-else>
                <textarea
                  id="inputNewItemInChecklist"
                  class="lego-input textarea-item"
                  placeholder="¿De que trata este paso este paso?"
                  @keydown.esc="closeControlsInItemInChecklist"
                  @keydown.enter="addItemInChecklistCtrlEnter"
                  @input="resizeTextarea($event)"
                  v-model="itemInChecklist"
                ></textarea>
                <div class="checklist-add-item--controls">
                  <vs-button @click="addItemInChecklist">Crear item</vs-button>
                  <vs-button danger @click="closeControlsInItemInChecklist"
                    >Cerrar</vs-button
                  >
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.title {
  border: none;
  font-size: 1.1rem;
  color: var(--text-progress) !important;
  margin-bottom: 0.8rem;
  padding: 0.2rem 0 0rem 0.5rem;
  border-radius: 0px;
  margin-right: 1rem;
  margin-bottom: 0;
}

.title-box {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.title.lego:focus {
  border: none;
  box-shadow: 0 1px 0 0 rgba(255, 255, 255, 0.5);
}

.item-display {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 0.5rem;
  margin-bottom: 0.8rem;
}

.sub-item-input,
.sub-items {
  grid-column: 1 / -1;
  margin-left: 20px;
  margin-top: 0.5rem;
}

.span-2 {
  grid-column-start: 1;
  grid-column-end: 3;
}

.in-right {
  grid-column-start: 2;
}

.title-section,
.title-icon {
  font-size: 1.1rem;
  display: flex;
  gap: 0.5rem;
}

.title-icon {
  font-size: 1.2rem;
}

.btn-shadow {
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
  gap: 0.25rem;
}

.tp-controls {
  display: flex;
  justify-content: flex-start;
  margin-top: 0.5rem;
  gap: 0.5rem;
}

.tp-controls > * {
  margin: 0;
}

.checklist {
  margin: 2rem 0 1rem;
}

.header-checklist {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-bottom: 0.5rem; */
}

.trash-icon-checklist {
  opacity: 0;
  transition: 0.3s;
}

.header-checklist:hover .trash-icon-checklist {
  opacity: 1;
}

.checklist-add-item {
  margin-top: 0.8rem;
}

.textarea-item {
  font-size: 0.9rem;
  min-height: auto;
}

.checklist-add-item--controls {
  display: flex;
  justify-content: flex-start;
  margin-top: 0.5rem;
  gap: 0.5rem;
}

.checklist-add-item--controls > * {
  margin: 0;
}

.item-in-checklist {
  border-radius: 5px;
  padding: 0.5rem;
  background-color: var(--lego-dbg);
  cursor: move;
  transition: all 0.2s ease;
  .dark & {
    background-color: var(--lego-bg);
  }
}

.sub-item {
  cursor: move;
  transition: all 0.2s ease;
}

/* Indicador de arrastre */
.drag-indicator {
  opacity: 0.3;
  transition: opacity 0.2s ease;
  color: var(--text-progress);
  margin-left: 0.1rem;
}

.item-in-checklist:hover .drag-indicator,
.sub-item:hover .drag-indicator {
  opacity: 0.7;
}

.dark .drag-indicator {
  color: var(--text-progress);
}

.item-in-checklist:last-child {
  margin-bottom: 0.2rem;
}

.item-in-checklist--right {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-left: 1rem;
}

.item-in-checklist--right textarea {
  border: none;
  min-height: auto;
  font-size: 0.8rem;
  padding: 0.2rem 0;
}

.item-in-checklist--right textarea:focus {
  padding: 0.2rem 0.4rem;
  background-color: var(--lego-oscuro);
  border: 1px solid #e1e5e9;
  /* border-radius: 4px; */
  outline: none;
}

.dark .item-in-checklist--right textarea:focus {
  background-color: var(--lego-bg);
  border-color: var(--lego-hoscuro);
}

.btn-checked {
  height: 21px;
  width: 21px;
  border: 2px solid var(--lego-hoscuro);
  transition: all 0.2s ease;
}

.btn-checked:disabled,
.btn-checked[disabled] {
  border: 2px solid var(--lego-hoscuro);
  opacity: 0.7;
}

.dark .btn-checked {
  border-color: var(--lego-hoscuro);
}

/* Estilos para mantener el borde visible durante la operación */
.btn-checked.waiting,
.btn-checked[data-waiting="true"] {
  border: 2px solid var(--lego-hoscuro) !important;
  opacity: 0.7;
  pointer-events: none;
}

/* Asegurar que el borde sea visible en modo claro */
.btn-checked {
  background-color: transparent;
  border-radius: 4px;
}

.btn-checked:hover {
  border-color: var(--primary);
  transform: scale(1.05);
}

.checklistItemControls {
  display: flex;
  align-items: center;
  transition: 0.3s;
  opacity: 0;
}

.item-in-checklist:hover .checklistItemControls {
  opacity: 1;
}

.btn-delete-checklist {
  transition: 0.3s;
  cursor: pointer;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  border-radius: 8px;
}

.btn-delete-checklist:hover {
  box-shadow: 0 0 0 2px var(--lego-danger);
}

.checklist-rendered {
  white-space: pre-wrap;
  cursor: pointer;
  width: 100%;
}

.checklist-rendered a {
  color: var(--primary);
  text-decoration: underline;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
.chevron-icon {
  margin-left: 0.5rem;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
